import { faCheck } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import TopBar from 'components/layout/TopBar';
import { callAxios, formatError } from 'components/utils/FormatData';
import { genKey, setStorage } from 'components/utils/Storage';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import MyButton from '../../components/form/MyButton';
import MyForm from '../../components/form/MyForm';
import ReturnTopBar from '../../components/layout/ReturnTopBar';
import { URL_API } from '../../constants/settings';
import useWindowSize from '../../hooks/useWindowSize';


const CreateOrEditCommand = (props) => {
  const params = useParams();
  const alert = useAlert();
  const history = useHistory();
  const [width, height] = useWindowSize();
  const [componentHeight, setComponentHeight] = useState(height - 295);
  const [command, setCommand] = useState({
    libelle: '',
    commande: '',
    famille: '',
  });
  const [listFamily, setListFamily] = useState([]);
  const form = [
    {
      id: 'libelle',
      label: 'LIBELLÉ',
      required: true,
      type: 'text',
      readOnly: false,
    },
    {
      id: 'commande',
      label: 'COMMANDE',
      required: true,
      type: 'text',
      readOnly: false,
      multiline: true,
      maxRows: 10,
    },
    {
      id: 'famille',
      label: 'FAMILLE D\'ÉQUIPEMENT',
      type: 'select',
      options: listFamily,
      value: command.famille,
    },
  ];
  const auth = useSelector(state => state["authentification"]);

  useEffect(() => {
    if (params["id"]) {
      document.title = `SED - Modification d'une commande`;
    } else {
      document.title = `SED - Création d'une commande`;
    }
    if (auth.profil !== 1 && auth.profil !== 2) {
      alert.error(`Vous n'êtes pas autorisé à accéder à cet écran`);
      history.push('/');
    }
  }, []);
  useEffect(() => {
    setComponentHeight(height - (225 + document.getElementById('component-topbar').clientHeight));
  }, [width, height]);
  useEffect(() => {
    if (listFamily.length > 0 && params["id"]) {
      fetchDetailCommande();
    }
  }, [listFamily]);
  useEffect(() => {
    if (props.wsStatus !== null) {
      fetchListFamily();
    }
  }, [props.wsStatus]);

  const fetchDetailCommande = () => {

    callAxios(props.wsStatus, "param_detail_commande", { method: 'get', url: URL_API + '/commandes-references/' + params["id"] }, null, alert)
      .then((res) => {
        setCommand(res);
        setStorage(genKey("param_detail_commande"), res);
      });

  };
  const fetchListFamily = () => {

    callAxios(props.wsStatus, "param_list_familles", { method: 'get', url: URL_API + '/familles' }, null, alert)
      .then((res) => {
        setListFamily(transformDatas(res));
        setStorage(genKey("param_list_familles"), res);
      });

  };
  const handleOnChangeValue = (value, type) => {
    setCommand({ ...command, [type]: value });
  };
  const handleOnValid = () => {
    if (command.libelle && command.commande && command.famille) {

      // Màj d'une commande
      if (params["id"]) {
        axios({ method: 'put', url: URL_API + '/commandes-references/' + params["id"], data: command })
          .then(function () {
            alert.success('La commande [' + command.commande + '] a bien été mise à jour avec succès');
            history.push('/parametres/gestion-commandes-references');
          })
          .catch(function (err) {
            formatError(alert, err);
          });

      } else {  // Création d'une commande

        axios({ method: 'post', url: URL_API + '/commandes-references', data: command })
          .then(function () {
            alert.success('La commande [' + command.commande + '] a été créée avec succès');
            history.push('/parametres/gestion-commandes-references');
          })
          .catch(function (err) {
            formatError(alert, err);
          });
      }

    } else {
      alert.error(`Vous devez renseigner l'ensemble des champs avant de continuer`);
    }
  };
  const transformDatas = (datas) => {
    const formattedDatas = [];

    datas.map((d) => {
      formattedDatas.push({ value: d, label: d });
    });

    return formattedDatas;
  };

  return (
    <div id="users" className={!isMobile ? 'panel-contenu' : 'panel-contenu-mobile-tablette'}
      style={{ height: !isMobile ? height - 110 : height - 60 }}>
      <TopBar title={params["id"] ? "modification d'une commande" : "création d'une commande"} className={!isMobile ? 'topbar-contenu' : 'topbar-contenu-mobile-tablette'}
        color={props.params.color} buttons={<ReturnTopBar url="/parametres/gestion-commandes-references" />} />

      <div className="composant-content-center" style={{ height: componentHeight, overflow: 'auto' }}>
        <div style={{ margin: '15px', padding: '15px', width: '85%' }}>

          <MyForm data={command} setData={setCommand} form={form} onChange={handleOnChangeValue} wsStatus={props.wsStatus} />

          <div className="row-center" style={{ marginTop: '50px' }}>

            {
              props.wsStatus &&
              <MyButton
                className="my-button"
                type="button"
                href="#"
                label="VALIDER"
                styleCss={{ backgroundColor: '#A3C745', height: '30px' }}
                iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
                onClick={handleOnValid}
              />
            }
            {
              !props.wsStatus &&
              <MyButton
                className="my-button"
                type="button"
                href="#"
                label="VALIDER"
                styleCss={{ backgroundColor: '#8ca0a8', height: '30px', cursor: 'default' }}
                iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
              />
            }

          </div>
        </div>
      </div>
    </div>
  );

};

export default CreateOrEditCommand;